import { Injectable, inject } from '@angular/core';
import { Observable, catchError, finalize, map, of, shareReplay, throwError } from 'rxjs';

import { AuthApiService } from './auth-api.service';
import { StorageService } from './storage.service';
import { AuthStoreService } from './auth-store.service';

@Injectable({ providedIn: 'root' })
export class SessionRefreshService {
  private readonly authApi = inject(AuthApiService);
  private readonly authStore = inject(AuthStoreService);
  private readonly storage = inject(StorageService);

  private refreshRequest$: Observable<string | null> | null = null;
  private refreshRequestToken: string | null = null;

  refreshAccessToken(): Observable<string | null> {
    const refreshToken = this.storage.getRefreshToken();
    if (this.refreshRequest$ && this.refreshRequestToken === refreshToken) {
      return this.refreshRequest$;
    }

    if (!refreshToken) {
      return of(null);
    }

    const request$ = this.authApi
      .refresh({ refreshToken })
      .pipe(
        map((response) => {
          if (this.storage.getRefreshToken() !== refreshToken) return null;
          this.authStore.applySession(response);
          return response.token;
        }),
        catchError((error) => {
          if (this.storage.getRefreshToken() === refreshToken) this.authStore.logout(false);
          return throwError(() => error);
        }),
        finalize(() => {
          if (this.refreshRequest$ === request$) {
            this.refreshRequest$ = null;
            this.refreshRequestToken = null;
          }
        }),
        shareReplay(1)
      );

    this.refreshRequest$ = request$;
    this.refreshRequestToken = refreshToken;
    return request$;
  }
}
